import { API_BASE_URL } from "../../../../constants";

// The athlete Performance section's one request (spec B14 A): the
// performance cards of one athlete and season,
//   GET business/athletes/about/id/<athleteId>/performance/?season=<key>
//   GET business/athletes/about/<email>/performance/?season=<key>
// Its own module on purpose: 32 suites factory-mock athleteServices with a
// fixed list of functions, so a new export there would be undefined in
// them. It uses fetch (as the store's actions do), not axios: the axios
// build is an ES module the test runner does not compile, and ProfileBody,
// which some 30 suites render, loads this module. The JWT comes from
// localStorage (the admin "open as user" overlay answers that read too).
//
// fetchAthletePerformance({ athleteId, email, season }) resolves to
// { status, data }: 200 with the envelope, or 202 while the server is
// still building it ({ available: false, status: "building", retryAfter }).
// Any other answer, or no network, rejects (the error carries the HTTP
// `status` when there was one); useAthletePerformance turns that into an
// unavailable section, never an error on the page.

const OBJECT_ID = /^[a-f0-9]{24}$/i;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
  Accept: "application/json",
});

// The endpoint path for an athlete: by id when the profile has a database
// id, else by email; null with neither.
export const performancePath = ({ athleteId, email } = {}) => {
  const id = String(athleteId ?? "").trim();
  if (OBJECT_ID.test(id)) return `/business/athletes/about/id/${id}/performance/`;
  const address = String(email ?? "").trim();
  if (address) return `/business/athletes/about/${encodeURIComponent(address)}/performance/`;
  return null;
};

export const performanceUrl = ({ athleteId, email, season } = {}) => {
  const path = performancePath({ athleteId, email });
  if (!path) return null;
  const key = String(season ?? "").trim();
  return `${API_BASE_URL}${path}${key ? `?season=${encodeURIComponent(key)}` : ""}`;
};

export const fetchAthletePerformance = async ({ athleteId, email, season } = {}) => {
  const url = performanceUrl({ athleteId, email, season });
  if (!url) return { status: 200, data: { available: false, reason: "no_record" } };
  if (typeof fetch !== "function") throw new Error("No network");
  const response = await fetch(url, { method: "GET", headers: authHeaders() });
  if (!response || !response.ok) {
    const err = new Error(`HTTP ${response?.status ?? 0}`);
    err.status = response?.status ?? 0;
    throw err;
  }
  let data = null;
  try {
    data = await response.json();
  } catch (err) {
    data = null;
  }
  return { status: response.status, data };
};
